import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountFields } from 'data/fields/hooks/account-fields';

const initialState: AccountFields = {
  accountId: null,
  accountName: null,
  objectType: 'TASK',
  fields: [],
  projectPhaseField: { fields: [] },
};

const taskFieldsSlice = createSlice({
  name: 'taskFields',
  initialState,
  reducers: {
    saveFields(state, { payload }: PayloadAction<AccountFields>) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const taskFieldsReducer = taskFieldsSlice.reducer;
export const { saveFields } = taskFieldsSlice.actions;
export const stateName = taskFieldsSlice.name;
